import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Register the service worker, which is what lets an operator install this to a
 * phone's home screen. See `public/sw.js` for what it will and will not cache —
 * the short version is that `/api` is never touched.
 *
 * Production only. In development the worker would sit in front of Vite's dev
 * server and serve yesterday's shell after an edit, which is a confusing bug to
 * chase and buys nothing: nobody installs localhost.
 *
 * Failures are swallowed. Registration is refused outright on an insecure
 * origin and by some privacy modes, and the console works perfectly well
 * without it — the only thing lost is the install prompt, and an error banner
 * over a working deposit queue would be a worse trade.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
